import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiResetPassword } from '../../services/api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get('token') || '', [params]);
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    const data = await apiResetPassword(token, password);
    if (data.error) {
      setError(data.error);
      return;
    }

    setMessage(data.message || 'Senha redefinida com sucesso.');
  };

  return (
    <div className="page-container">
      <div className="card">
        <h1 className="card-title">Redefinir senha</h1>
        {!token && <p className="api-error">Token ausente na URL.</p>}

        <form onSubmit={handleSubmit}>
          {error && <p className="api-error">{error}</p>}
          {message && <p className="api-success">{message}</p>}

          <div className="form-group">
            <label htmlFor="new-password">Nova senha</label>
            <input
              id="new-password"
              type="password"
              minLength="6"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          <button className="submit-btn" type="submit" disabled={!token}>Salvar nova senha</button>
        </form>

        <p className="toggle-text">
          <Link to="/login" className="toggle-btn">Voltar ao login</Link>
        </p>
      </div>
    </div>
  );
}
